import { render } from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=template&id=ca88ac32"
import script from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceMoneyDetailsDesign3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__